export default __webpack_public_path__ + "static/img-6-f6e44eac8e078b43411aaae356a8971c.png";